import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CurrentAuthenticationState } from '@warema/shared/authentication/models';
import { AuthenticationState, authenticationFeatureKey } from './authentication.reducers';

const selectState = createFeatureSelector<AuthenticationState>(authenticationFeatureKey);

const selectUser = createSelector(selectState, state => state.user);

const selectToken = createSelector(selectState, state => state.token);

const selectCurrentAuthenticationState = createSelector(selectState, state => {
    let retVal: CurrentAuthenticationState = 'initializing';

    if (state.initializing) {
        return retVal;
    }

    if (state.token === null) {
        retVal = 'unauthenticated';
    } else if (state.user !== null) {
        retVal = 'authenticationComplete';
    } else if (state.userError !== null) {
        retVal = 'userError';
    } else {
        retVal = 'userLoading';
    }

    return retVal;
});

const selectAuthenticationComplete = createSelector(selectCurrentAuthenticationState, state => {
    switch (state) {
        case 'initializing':
        case 'userLoading':
            return false;
        case 'unauthenticated':
        case 'authenticationComplete':
        case 'userError':
            return true;
    }
});

export const fromAuthentication = {
    selectUser,
    selectToken,
    selectCurrentAuthenticationState,
    selectAuthenticationComplete,
};
